import Vue from 'vue';
import {listenKeybord} from '@/utils/util';
Vue.directive('input', {
  bind: function (el, binding, vnode) {
    let up = () => {}; 
    let down =() => {};
    if (binding.value) {
      up = binding.value.up;
      down = binding.value.down;
    }
    listenKeybord(el,up,down);
  },
  inserted: function (el) {
    // console.log(el);
  },
  updated: function (el) {
    // console.log(el);
  }
});